import { z } from 'zod'

/** Source health's line tabs, in order, and their labels. Scrapers is the one it opens on. */
export const SOURCE_HEALTH_TABS = {
  scrapers: 'Scrapers',
  budget: 'Budget',
  coverage: 'Coverage',
  log: 'Log',
} as const

export type SourceHealthTab = keyof typeof SOURCE_HEALTH_TABS

const TAB_KEYS = Object.keys(SOURCE_HEALTH_TABS) as [SourceHealthTab, ...SourceHealthTab[]]

/**
 * Source health's search: the tab, in the address so a link opens that tab. An unreadable one is
 * dropped, which opens Scrapers.
 */
export const sourceHealthSearchSchema = z.object({
  tab: z.enum(TAB_KEYS).optional().catch(undefined),
})

export type SourceHealthSearch = z.infer<typeof sourceHealthSearchSchema>
